import type { FC, MouseEventHandler } from 'react';
import { useState, useCallback, useEffect, useRef } from 'react';
import { Picture } from '@ui';
import icons from '@icons';
import { observer } from 'mobx-react';
import CatalogBtnMobileList from './components';
import { useStores } from '@root/src/stores';
import { lockBodyScroll, unlockBodyScroll } from '@utils/scrollLock';
import { useLocation } from '@compat/router';
import { OPEN_MOBILE_CATALOG_EVENT, CLOSE_MOBILE_CATALOG_EVENT, MOBILE_CATALOG_VISIBILITY_EVENT } from '@constants/customEvents';

const {
  menu: { black: menuBlackOutlined },
  chevronLeft: { red: clRedOutlined },
  ng: { black: ngBlackOutlined }
} = icons.Outline;

const isNewYear = false;

const CatalogBtnMobile: FC = observer(() => {
  const { pathname } = useLocation();
  const { catalogStore } = useStores();
  const { menu } = catalogStore;
  const [isShow, setIsShow] = useState(false);
  const pathnameRef = useRef(pathname);

  const hide = useCallback((): void => {
    setIsShow(false);
  }, []);
  const toggle: MouseEventHandler<HTMLDivElement> = useCallback(
    (e): void => {
      e.stopPropagation();
      if (isShow) {
        hide();
      } else {
        setIsShow(true);
      }
    },
    [isShow, hide]
  );

  useEffect(() => {
    if (pathnameRef.current === pathname) {
      return;
    }
    pathnameRef.current = pathname;
    setIsShow(false);
  }, [pathname]);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent(MOBILE_CATALOG_VISIBILITY_EVENT, { detail: isShow })
    );
  }, [isShow]);

  useEffect(() => {
    if (!isShow) {
      return;
    }
    lockBodyScroll();
    return unlockBodyScroll;
  }, [isShow]);

  useEffect(() => {
    const show = (): void => {
      setIsShow(true);
    };
    const close = (): void => {
      setIsShow(false);
    };

    window.addEventListener(OPEN_MOBILE_CATALOG_EVENT, show);
    window.addEventListener(CLOSE_MOBILE_CATALOG_EVENT, close);
    return () => {
      window.removeEventListener(OPEN_MOBILE_CATALOG_EVENT, show);
      window.removeEventListener(CLOSE_MOBILE_CATALOG_EVENT, close);
    };
  }, []);

  return (
    <>
      <div>
        <div
          onClick={toggle}
          className='flex items-center w-6 h-6 font-medium sm:mr-1 '
        >
          <Picture
            icon={
              isShow
                ? clRedOutlined
                : isNewYear
                ? ngBlackOutlined
                : menuBlackOutlined
            }
            height='24'
            width='24'
          />
        </div>
        <CatalogBtnMobileList hide={hide} list={menu} isShow={isShow} />
      </div>
    </>
  );
});

export default CatalogBtnMobile;
